import * as Lucide from "lucide-react";

// Renders a lucide-react icon by name string. Falls back to Wrench.
export default function Icon({ name, ...props }) {
  const Cmp = Lucide[name] || Lucide.Wrench;
  return <Cmp {...props} />;
}
